import _ from "lodash"

// test: jest src/models/__tests__/Booking.model.spec.js
export default class Booking {
  constructor(rawData) {
    this._rawData = rawData;
  }

  get serviceIdInArray() {
    if (!_.get(this._rawData, 'service_id')) {
      return []
    }
    const parsedServiceId = JSON.parse(_.get(this._rawData, 'service_id'))
    return Array.isArray(parsedServiceId) ? parsedServiceId : [parsedServiceId]
  }

  get value() {
    return _.get(this._rawData, 'value')
  }
}
